import { render } from "./FungiHomeView.vue?vue&type=template&id=6337cf52"
import script from "./FungiHomeView.vue?vue&type=script&lang=js"
export * from "./FungiHomeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__